import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppPushRules - the words and the wire of "Notifications" (`AppPush`), habitat-free so
// the Bridge suite pins them against `/push` (`Bridge/src/PushRules`). See `AppPush` for the whole feature.

/** The meaning of `/push`'s answers (pure; the Bridge suite pins it against the service). */
export class AppPushRules {
    public static readonly Route: string = "/push";
    public static readonly Attr: string = "data-wac-push";
    public static readonly Words: string = "Notifications";
    public static readonly Tip: string = "A notification with the contact's name when a message arrives - also while WACommander is closed.";
    public static readonly OnWords: string = "Notifications are on for this device.";
    public static readonly OffWords: string = "Notifications are off for this device.";
    public static readonly DeniedWords: string = "Notifications are blocked for this site - allow them in the browser's site settings, then try again.";
    public static readonly NotYetWords: string = "Notifications aren't available yet.";
    public static readonly FailedWords: string = "Notifications could not be turned on on this device.";

    /** The request body (this browser's number + archive key); "" when it holds none. */
    public static Body = (Number: string, Key: string, Action: string, Extra: Record<string, unknown>): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (Number.length === 0 || Key.length === 0) { return ""; }
            return JSON.stringify(Object.assign({ number: Number, key: Key, action: Action }, Extra));
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppPushRules.Body");
            return "";
        }
    };

    /** `{ok, key}` -> the key, else "" and the sentence. No boolean `ok` (a dormant service) = "not available yet". */
    public static Parse = (Status: number, Text: string): { Ok: boolean; Key: string; Why: string } => {
        const Out: { Ok: boolean; Key: string; Why: string } = { Ok: false, Key: "", Why: AppPushRules.NotYetWords };
        if (getCoreUtils().KErrorMode === true) { return Out; }
        try {
            if (Status !== 200) { return Out; }
            const Doc: Record<string, unknown> = JSON.parse(nz(Text)) as Record<string, unknown>;
            if (Doc === null || typeof Doc !== "object" || typeof Doc.ok !== "boolean") { return Out; }
            if (Doc.ok !== true) { Out.Why = String(nz(Doc.why as string)); return Out; }
            Out.Ok = true;
            Out.Why = "";
            if (typeof Doc.key === "string") { Out.Key = Doc.key; }
            return Out;
        } catch (e) {
            // ERROR-SUPPRESSED-JUSTIFIED: an answer that is not JSON is a service not offering push yet (fate 1).
            return Out;
        }
    };
}
